import React from 'react'
import styles from './psq.module.scss'
import { Trans } from 'react-i18next'
import InfoBox from 'components/generic/InfoBox'

const FillOnceAlert = () => (
  <InfoBox className={styles.infoBox} iconColor='red'>
    <p>
      <Trans ns='strPsq' i18nKey={'infoBox'}>
        You’ll only be able to fill this in <strong>once.</strong>
        <br />
        <strong>You won’t be able to change</strong> your answers, so please make sure you complete
        it correctly.
      </Trans>
    </p>
  </InfoBox>
)

export default FillOnceAlert
